<div class="main-div">
    <div class="row ms-0 me-0" id="air-freight">
        <div class="col-xl-6 ps-0 pe-0 arrow-overlap-img">
            <img src="../assets/images/our-services/air-services/air-freight.jpg" alt="Air Freight" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 bg-img-top">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">01.</span> Air Freight</h2>
                <p class="font-16">Our custom air freight solutions provide an optimal combination of lead time and cost-efficiency to meet your expectations and fulfill your specific needs.</p>
                    <p class="font-16">With our high level of customer care and a service network comprised of contracts with major carriers, as well as many niche operators, 
                        we provide coverage door-to-door globally.</p>
            </div>
        </div>
    </div>

    <div class="row ms-0 me-0" id="express">
        <div class="col-xl-6 ps-0 pe-0 order-2 res-order-1 arrow-overlap-img-top">
            <img src="../assets/images/our-services/air-services/express-image.jpg" alt="Express" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 order-1 bg-img-bottom">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">02.</span> Express</h2>
                <p class="font-16">Express courier service available in Denmark for import, export and cross-trade shipments offering real-time rates, booking, and tracking online via our multi-carrier platform.</p>
                <!-- <p class="font-16">Click <a href="http://straitair.wallbee.dk" target="_blank" class="more-link font-16" style="font-size: 16px;">here</a> to login.</p> -->
                <p class="font-16">Click <a href="http://kurer.straitair.com/" target="_blank" class="more-link font-16" style="font-size: 16px;">here</a> to login</p>
                <p class="font-16">To learn more and register for this service, email us at <a href="mailto:express@straitair.com" class="more-link font-16" style="font-size: 16px;text-decoration: none">express&#64;straitair.com</a></p>
            </div>
        </div>
    </div>

    <div class="row ms-0 me-0" id="charter">
        <div class="col-xl-6 ps-0 pe-0 arrow-overlap-img-top">
            <img src="../assets/images/our-services/air-services/charter.png" alt="Charter" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 bg-img-bottom">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">03.</span> Charter</h2>
                <p class="font-16">We provide full- and part-charter when regular air freight cannot meet critical timing, reach a remote destination, load your heavy & oversized cargo, or transport sensitive & dangerous goods.
                    <br><br> With 3rd party liability insurance in place, we can secure the ideal large or small aircraft tailored to your needs and not limited to carriers.
                    <br><br> Our specialized staff provide origin and destination handling to ensure all documentation and permits are in order in addition to securing an aircraft licensed for your cargo.</p>
            </div>
        </div>
    </div>

    <div class="row ms-0 me-0" id="obc">
        <div class="col-xl-6 ps-0 pe-0 order-2 res-order-1 arrow-overlap-img-top">
            <img src="../assets/images/our-services/air-services/obc-image.jpg" alt="OBC" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 order-1 bg-img-bottom">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">04.</span> On Board Courier (OBC)</h2>
                <p class="font-16">Our OBC service provides the fastest, most reliable, and secure hand carried delivery. Offering 24/7/365 priority pick-up and delivery to and from anywhere in the world with real-time notifications or alerts.
                    <br><br> Same day service available within Europe and 1-2 day service for the rest of world.</p>
            </div>
        </div>
    </div>
</div>


<section class="service-sub-full-bg" id="sea-air">
    <div class="container-fluid">
        <div class="row ms-0 me-0">
            <div class="col-lg-6 order-1 bg-img-bottom">
                <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                    <h2 class="mb-4 yellow-text"><span class="number">05.</span> Sea/Air</h2>
                    <p class="font-16 text-white">Combine your transport moving part way via sea to take advantage of preferred air freight rates and reduce transit times in most cases by half. We can arrange the perfect Sea/Air solution to save you both time and money when moving
                        your goods and even eliminate warehousing costs by minimizing your need to store inventory locally.</p>
                </div>
            </div>
        </div>
    </div>
</section>